const $win = $(window);
const $doc = $(document);
const TABLET_WIDTH = 1024;

const $filters = $('.js-filters');
const currentCollection = $filters.data('collection');
const $colorsHolder = $('.js-colors-holder');

if ($filters.length) {
  let lastPartOfHref = '';
  let selectedValuesArray = '';
  let windowPath = '';
  let windowSearch = '';
  let newHref = '';
  let newoptionHref = '';

  const currentStates = () => {
    windowPath = window.location.pathname;
    windowSearch = window.location.search;

    if (windowSearch.indexOf('?page=') > -1) {
      windowSearch = '';
    }

    lastPartOfHref = windowPath.split('/').length > 3 ? windowPath.split('/')[windowPath.split('/').length - 1] : '';
    selectedValuesArray = lastPartOfHref.split('+');

    let colorName = '';

    // Show clear links

    if (selectedValuesArray.length > 0 && selectedValuesArray[0] != '') {
      $('.js-clear-all').removeClass('hidden-lg hidden-md');

      selectedValuesArray.map((tag) => {
        if (tag.includes('color-')) {
          colorName = tag.replace('color-', '');
        }

        // Set current class of selected options
        $filters
          .find(`a[href="${tag}"]`)
          .parent()
          .addClass('current')
          .closest('.filter__option')
          .addClass('filter__option--selected');
      });

      if (colorName !== '' && $colorsHolder.length) {
        $colorsHolder.find('input').prop('checked', false);

        const $selectedColor = $colorsHolder.find(`[data-handle-name="${colorName}"]`);

        $selectedColor.each(function() {
          const $this = $(this);
          const imageSrc = $this.data('variant-image');

          $this.prop('checked', true);

          $this
            .closest('.js-product')
            .find('.js-image')
            .attr('src', imageSrc);
        });
      }
    }
  };

  currentStates();

  $doc.on('click', '.js-filter-toggle', function(event) {
    event.preventDefault();

    const $this = $(this);
    $this
      .closest('.filter__option')
      .toggleClass('is-expanded')
      .siblings()
      .removeClass('is-expanded');

    const dropdownExpanded = $this.closest('.filter__option').hasClass('is-expanded');

    $this.closest('.section__head').toggleClass('is-dropdown-expanded', dropdownExpanded);

    if ($win.width() > TABLET_WIDTH) {
      $this.next().removeAttr('style');
    }
  });

  $doc.on('click', '.js-filters-toggle', function(event) {
    event.preventDefault();

    const $this = $(this);

    $('.section-products .section__head, .wrapper').toggleClass('is-filter-expanded');
    $('.filter, .section-products .section__controls').slideToggle();
    $('.is-dropdown-expanded, .is-expanded').removeClass('is-dropdown-expanded is-expanded');
  });

  $doc.on('click', '.js-filters .js-filter-option', function(event) {
    event.preventDefault();

    const $this = $(this);
    const optionHref = $this.attr('href');

    if ($this.parent().hasClass('current')) {
      newHref = lastPartOfHref.split('+');
      newHref = newHref.filter((tag) => tag !== optionHref).join('+');
    }

    if (!$this.parent().hasClass('current')) {
      const type = optionHref.split('-')[0];

      if (lastPartOfHref.includes(type)) {
        newHref = lastPartOfHref.split('+').filter((tag) => !tag.includes(type));
        newHref.push(optionHref);
        newHref = newHref.join('+');
      } else {
        newHref = lastPartOfHref !== '' ? `${lastPartOfHref}+${optionHref}` : `${optionHref}`;
      }
    }

    window.location = currentCollection + '/' + newHref + windowSearch;
  });
}


/**
 * Update items count
 * @param  {jQuery selector} $counter
 * @return {void}
 */
function itemsCountUpdate($counter) {
  $win.on('load', function() {
    const itemsCount = $('.product-items .product-item').length;

    if (itemsCount != 0) {
      $counter.text(itemsCount)
    };
  });
}

itemsCountUpdate($('.js-product-counter'));
